import { Typography, useTheme } from '@mui/material';
import { useTransition, type JSX } from 'react';
import { Checkbox } from '../../Checkbox/Checkbox';
import { StyledMenuItem, TypoWrapper } from '../styled';
import { MenuItemProps } from '../types';

export const MenuItem = ({
  col,
  provider,
  className,
  checkboxVariant = 'secondary',
}: MenuItemProps): JSX.Element => {
  const startTransition = useTransition()[1];
  const theme = useTheme();

  const checked = provider.selectedColumns.includes(col.name);

  const handleSelectDeselect = () => {
    startTransition(() => {
      let newOrder: string[];
      if (checked) {
        // Remove from selection
        newOrder = provider.selectedColumns.filter((name) => name !== col.name);
      } else {
        // Add to selection
        newOrder = [...provider.selectedColumns, col.name];
      }
      provider.setSelectedColumns(newOrder);
    });
  };

  return (
    <StyledMenuItem className={className}>
      <Checkbox handleChange={handleSelectDeselect} checked={checked} variant={checkboxVariant} />
      <TypoWrapper onClick={handleSelectDeselect}>
        <Typography variant='body2' color={theme.colors.primary[100]}>
          {col.displayName}
        </Typography>
      </TypoWrapper>

      <div>
        <Typography variant='caption' color={'text.secondary'} title={col.description}>
          {col.description}
        </Typography>
      </div>
    </StyledMenuItem>
  );
};
